import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import RenaultDigitalSrc from './bg_renault-digital.png'
import LogosSrc from './bg_logos.png'
import LogoSrc from './bg_logo_color.png'
import ClassCSrc from './bg_class_c.png'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

const Content = styled.div`
  flex-direction: column;
  height: calc(100vh - 35px);
  width: 100%;
  overflow: hidden;
  display: flex;
`;

const Footer = styled.footer`
  background-color: white;
  display: block;
  position: relative;
  width: 100%;
  height: 35px;
  margin: 10px 5px 15px;
`;

const DividedSection = styled.span`
  text-transform: uppercase;
  font-size: 13px;
  line-height: 44px;
  height: 100%;
  float: ${({ last }) => (last ? 'right' : 'left')};
  margin: ${({ last }) => (last ? '0 20px 0 0' : '0 160px 0 0')};

  &::after {
    opacity: ${({ last }) => (last ? 0 : 1)};
    content: '';
    width: 0;
    height: 20px;
    position: absolute;
    border: 0.5px solid black;
    top: 11px;
    margin-left: 140px;
  }
`;

const Confidential = styled.span`
  display: flex;
  line-height: 15px;
  float: left;
  padding-left: 10px;
  text-align: left;
  padding-top: 6px;
`;

export default function Index({ children }) {
  return (
    <Container>
      <Content>{children}</Content>
      <Footer>
        <DividedSection>
          <img
            style={{ height: 30, margin: '5px 0 0 0' }}
            alt="logos"
            src={LogosSrc}
          />
        </DividedSection>
        <DividedSection>
          <img
            style={{ margin: '11px 0 0 0' }}
            alt="logos"
            src={RenaultDigitalSrc}
          />
        </DividedSection>
        <DividedSection>{new Date().toLocaleDateString()}</DividedSection>
        <DividedSection>
          <img
            src={ClassCSrc}
            style={{ display: 'inline-block', float: 'left' }}
            alt="property"
          />
          <Confidential>
            CONFIDENTIEL / CONFIDENTIAL
            <br />
            propriété renault / renault property
          </Confidential>
        </DividedSection>
        <DividedSection last>
          <img
            style={{ height: 20, float: 'right', margin: '11px 0 0 0' }}
            alt="logos"
            src={LogoSrc}
          />
        </DividedSection>
      </Footer>
    </Container>
  )
}

Index.propTypes = {
  children: PropTypes.node.isRequired
};
